Object.defineProperty(exports, "__esModule", {
    value: true
});
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var _to_array = require("@swc/helpers/_/_to_array");
var require_constant = require('./constant.cjs');
var require_env = require('./env.cjs');
//#region src/utils.ts
var LOG_CATEGORY = "[ Federation Runtime ]";
var parseEntry = function parseEntry(str, devVerOrUrl) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : require_constant.SEPARATOR;
    var strSplit = str.split(separator);
    var devVersionOrUrl = require_env.getProcessEnv()["NODE_ENV"] === "development" && devVerOrUrl;
    var defaultVersion = "*";
    var isEntry = (s)=>s.startsWith("http") || s.includes(require_constant.MANIFEST_EXT);
    if (strSplit.length >= 2) {
        var _strSplit = _to_array._(strSplit), name = _strSplit[0], versionOrEntryArr = _strSplit.slice(1);
        if (str.startsWith(separator)) {
            name = strSplit.slice(0, 2).join(separator);
            versionOrEntryArr = [
                devVersionOrUrl || strSplit.slice(2).join(separator)
            ];
        }
        var versionOrEntry = devVersionOrUrl || versionOrEntryArr.join(separator);
        if (isEntry(versionOrEntry)) return {
            name,
            entry: versionOrEntry
        };
        else return {
            name,
            version: versionOrEntry || defaultVersion
        };
    } else if (strSplit.length === 1) {
        var _strSplit1 = _sliced_to_array._(strSplit, 1), name1 = _strSplit1[0];
        if (devVersionOrUrl && isEntry(devVersionOrUrl)) return {
            name: name1,
            entry: devVersionOrUrl
        };
        return {
            name: name1,
            version: devVersionOrUrl || defaultVersion
        };
    } else throw `Invalid entry value: ${str}`;
};
var composeKeyWithSeparator = function composeKeyWithSeparator() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (!args.length) return "";
    return args.reduce((sum, cur)=>{
        if (!cur) return sum;
        if (!sum) return cur;
        return `${sum}${require_constant.SEPARATOR}${cur}`;
    }, "");
};
var encodeName = function encodeName(name) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", withExt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    try {
        var ext = withExt ? ".js" : "";
        return `${prefix}${name.replace(new RegExp(`${require_constant.NameTransformSymbol.AT}`, "g"), require_constant.NameTransformMap[require_constant.NameTransformSymbol.AT]).replace(new RegExp(`${require_constant.NameTransformSymbol.HYPHEN}`, "g"), require_constant.NameTransformMap[require_constant.NameTransformSymbol.HYPHEN]).replace(new RegExp(`${require_constant.NameTransformSymbol.SLASH}`, "g"), require_constant.NameTransformMap[require_constant.NameTransformSymbol.SLASH])}${ext}`;
    } catch (err) {
        throw err;
    }
};
var decodeName = function decodeName(name, prefix, withExt) {
    try {
        var decodedName = name;
        if (prefix) {
            if (!decodedName.startsWith(prefix)) return decodedName;
            decodedName = decodedName.replace(new RegExp(prefix, "g"), "");
        }
        decodedName = decodedName.replace(new RegExp(`${require_constant.NameTransformMap[require_constant.NameTransformSymbol.AT]}`, "g"), require_constant.EncodedNameTransformMap[require_constant.NameTransformMap[require_constant.NameTransformSymbol.AT]]).replace(new RegExp(`${require_constant.NameTransformMap[require_constant.NameTransformSymbol.SLASH]}`, "g"), require_constant.EncodedNameTransformMap[require_constant.NameTransformMap[require_constant.NameTransformSymbol.SLASH]]).replace(new RegExp(`${require_constant.NameTransformMap[require_constant.NameTransformSymbol.HYPHEN]}`, "g"), require_constant.EncodedNameTransformMap[require_constant.NameTransformMap[require_constant.NameTransformSymbol.HYPHEN]]);
        if (withExt) decodedName = decodedName.replace(".js", "");
        return decodedName;
    } catch (err) {
        throw err;
    }
};
var generateExposeFilename = (exposeName, withExt)=>{
    if (!exposeName) return "";
    var expose = exposeName;
    if (expose === ".") expose = "default_export";
    if (expose.startsWith("./")) expose = expose.replace("./", "");
    return encodeName(expose, "__federation_expose_", withExt);
};
var generateShareFilename = (pkgName, withExt)=>{
    if (!pkgName) return "";
    return encodeName(pkgName, "__federation_shared_", withExt);
};
var getResourceUrl = (module, sourceUrl)=>{
    if ("getPublicPath" in module) {
        var publicPath;
        if (!module.getPublicPath.startsWith("function")) publicPath = new Function(module.getPublicPath)();
        else publicPath = new Function("return " + module.getPublicPath)()();
        return `${publicPath}${sourceUrl}`;
    } else if ("publicPath" in module) {
        if (!require_env.isBrowserEnv() && !require_env.isReactNativeEnv() && "ssrPublicPath" in module && typeof module.ssrPublicPath === "string") return `${module.ssrPublicPath}${sourceUrl}`;
        return `${module.publicPath}${sourceUrl}`;
    } else {
        console.warn("Cannot get resource URL. If in debug mode, please ignore.", module, sourceUrl);
        return "";
    }
};
var assert = (condition, msg)=>{
    if (!condition) error(msg);
};
var error = (msg)=>{
    throw new Error(`${LOG_CATEGORY}: ${msg}`);
};
var warn = (msg)=>{
    console.warn(`${LOG_CATEGORY}: ${msg}`);
};
function safeToString(info) {
    try {
        return JSON.stringify(info, null, 2);
    } catch (e) {
        return "";
    }
}
var VERSION_PATTERN_REGEXP = /^([\d^=v<>~]|[*xX]$)/;
function isRequiredVersion(str) {
    return VERSION_PATTERN_REGEXP.test(str);
}
//#endregion
exports.assert = assert;
exports.composeKeyWithSeparator = composeKeyWithSeparator;
exports.decodeName = decodeName;
exports.encodeName = encodeName;
exports.error = error;
exports.generateExposeFilename = generateExposeFilename;
exports.generateShareFilename = generateShareFilename;
exports.getResourceUrl = getResourceUrl;
exports.isRequiredVersion = isRequiredVersion;
exports.parseEntry = parseEntry;
exports.safeToString = safeToString;
exports.warn = warn; //# sourceMappingURL=utils.cjs.map
